import React, { FC } from 'react'
import { Flex } from 'rebass'
import Button from 'components/base/buttons/buttons'

interface Props {
	products: number
	totalProducts: number
	page: number
	pageSize: number
	loading: boolean
	previousPagePath: string
	handleLoadMore: () => void
}

const LoadPrevious: FC<Props> = ({
	products,
	totalProducts,
	page,
	pageSize,
	loading,
	previousPagePath,
	handleLoadMore,
}) => {
	const handleClick = (event: React.MouseEvent) => {
		event.preventDefault()
		handleLoadMore()
	}

	if (page > 1 && products > 0 && products < totalProducts && pageSize * page > products) {
		return (
			<Flex justifyContent="center" flexWrap="wrap" mb="6rem">
				<a href={previousPagePath} onClick={handleClick}>
					<Button isLoading={loading} primary clipText noFill>
						Sjá fyrri vörur
					</Button>
				</a>
			</Flex>
		)
	}
	return null
}

export default LoadPrevious
